import {
  CreateTopicRequest,
  Topic,
  TopicExampleModel,
  TopicExamplesPage,
  UpdateTopicRequest,
} from '../types/TopicModels';
import { htmlDecode } from '../utils/htmlDecode';
import { api } from './api';

const decodeTopic = (topic: Topic): Topic => ({
  ...topic,
  title: htmlDecode(topic.title),
  description: topic.description ? htmlDecode(topic.description) : undefined,
});

const decodeExample = (item: TopicExampleModel): TopicExampleModel => ({
  ...item,
  title: htmlDecode(item.title),
  description: item.description ? htmlDecode(item.description) : undefined,
  categoryName: htmlDecode(item.categoryName),
});

export const getTopics = async (token: string): Promise<Topic[]> => {
  const response = await api.get<Topic[]>('/v1/topics', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data.map(decodeTopic);
};

export const createTopic = async (
  request: CreateTopicRequest,
  token: string
): Promise<Topic> => {
  const response = await api.post<Topic>('/v1/topics', request, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return decodeTopic(response.data);
};

export const updateTopic = async (
  id: number,
  request: UpdateTopicRequest,
  token: string
): Promise<Topic> => {
  const response = await api.put<Topic>(`/v1/topics/${id}`, request, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return decodeTopic(response.data);
};

export const deleteTopic = async (id: number, token: string): Promise<void> => {
  await api.delete(`/v1/topics/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTopicExamples = async (
  token: string,
  categoryId?: number,
  page = 1,
  pageSize = 10
): Promise<TopicExamplesPage> => {
  const response = await api.get<TopicExamplesPage>('/v1/topics/examples', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      categoryId,
      page,
      pageSize,
    },
  });

  return {
    ...response.data,
    items: response.data.items.map(decodeExample),
  };
};